// MigrationHistory.jsx
import React, { useEffect } from "react";
import { Col, Row, Button, Container } from "react-bootstrap";
import Dashboardheader from "../../directives/dashboardheader";
import { useDispatch, useSelector } from "react-redux";
import { getMigrationHistory } from "../../redux/slicess/migrationDataSlice";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { claimMigrationAction, submitMigrationAction } from "../../Action/user.action";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";

const MigrationHistory = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id")
    const navigate = useNavigate();


    const { history, loading, error } = useSelector((state) => state.migrationHistory);

    useEffect(() => {
        dispatch(getMigrationHistory({ migration_id: id }));
    }, [dispatch]);

    const claimMigrateAmount = async (rowId) => {
        try {
            const data =
            {
                migration_id: rowId
            };
            console.log(data);
            const res = await claimMigrationAction(data);
            if (res.success) {
                toast.success(res.msg);
                navigate(-1);
            } else {
                toast.error(res.msg || "Claim failed");
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong!");
        }
    };
    const handleBackNavigation = () => {
        navigate(-1);
    };
    return (
        <>
            <Dashboardheader />
            <div className="position-relative">
                <div className="db1"></div>
                <div className="db4"></div>
                <div className="db5"></div>
                <div className="db6"></div>
                <div className="db7"></div>
                <div className="db8"></div>

                <Container className="px-sm-5 px-2 mb-5 text-white mt-5">
                    <div
                        onClick={handleBackNavigation}
                        style={{ cursor: "pointer" }}
                        className="d-flex gap-2 align-items-center text-white mb-3"
                    >
                        <p className="mb-0 d-flex align-items-center">
                            <IoIosArrowRoundBack size={25} /> Back
                        </p>
                    </div>
                    <div className="card card-view rounded-20 border-0">

                        <div className="card-body">
                            <div>
                                <h3 className="sofia-sans">Migration History</h3>
                                <br />

                                {loading && <p>Loading migration history...</p>}
                                {error && <p className="text-danger">{error}</p>}

                                {/* History list */}
                                {history?.length > 0 ? (
                                    history.map((item, index) => (
                                        <Row key={index} className="sofia-sans">
                                            <Col xl={12}>
                                                <div
                                                    style={{
                                                        background: "rgba(221, 63, 255, 0.1)",
                                                        borderRadius: 10,
                                                        textTransform: "capitalize",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <Row className="gy-2 px-3 pt-3 mt-2 justify-content-between sofia-sans">
                                                        <Col className="text-center">
                                                            <p className="text-secondary wcard-title mb-2">Migration Date</p>
                                                            <p className="wcard-data">{item.release_date}</p>
                                                        </Col>
                                                        <Col className="text-center">
                                                            <p className="text-secondary wcard-title mb-2">Migration Amount</p>
                                                            <p className="wcard-data fw-bold">{item.balance_amount} Token</p>
                                                        </Col>
                                                        <Col className="text-center">
                                                            <p className="text-secondary wcard-title mb-2">Released Coin</p>
                                                            <p className="wcard-data">{item.release_amount}</p>
                                                        </Col>
                                                        <Col className="text-center d-flex align-items-baseline justify-content-center">
                                                            <Button
                                                                variant="main2"
                                                                className="w-100 mb-3"
                                                                disabled={!item.is_enable}
                                                                onClick={() => claimMigrateAmount(item.detail_id)}
                                                            >
                                                                {item.claim}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    ))
                                ) : (
                                    !loading && (
                                        <div
                                            className="text-center d-flex justify-content-center align-items-center flex-column"
                                            style={{
                                                padding: "20px",
                                                color: "#d3d3d3",
                                                borderRadius: "8px",
                                                height: "80vh",
                                            }}
                                        >
                                            <img
                                                style={{ width: "auto", height: "auto" }}
                                                src="assets/images/newdesign/nodata-new.png"
                                                alt="No Data"
                                            />
                                            <h4>No data found</h4>
                                        </div>
                                    )
                                )}

                                {/* Load More */}
                                {history?.length >= 10 && (
                                    <div className="text-center mt-3">
                                        <Button variant="main2">Load More</Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default MigrationHistory;
